/**
 * Kerncijfers die optellen zodra ze in beeld komen.
 *
 * Werkt op de tekst zoals die er staat: uit "40+" wordt 40 geteld en blijft de plus
 * staan, uit "1923" gewoon 1923. Staat er geen getal in, dan blijft de tekst met rust.
 * Eén keer per cijfer -- terugscrollen laat het niet opnieuw lopen, dat leidt af.
 */

import gsap from 'gsap';

export default function initStats() {
  const values = document.querySelectorAll('[data-stat-value]');

  if (! values.length || typeof IntersectionObserver === 'undefined') {
    return;
  }

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (! entry.isIntersecting) {
        return;
      }

      observer.unobserve(entry.target);
      count(entry.target);
    });
  }, { threshold: 0.5 });

  values.forEach((element) => {
    if (parse(element.textContent)) {
      observer.observe(element);
    }
  });
}

/**
 * Splitst "40+" in wat ervoor staat, het getal en wat erachter staat.
 */
function parse(text) {
  const match = String(text).match(/^(\D*)([\d.,]+)(\D*)$/);

  if (! match) {
    return null;
  }

  const grouped = /[.,]/.test(match[2]);
  const number = parseInt(match[2].replace(/[.,]/g, ''), 10);

  return Number.isNaN(number) ? null : {
    prefix: match[1],
    suffix: match[3],
    number,
    grouped,
  };
}

function count(element) {
  const parts = parse(element.textContent);

  if (! parts) {
    return;
  }

  // Breedte vastzetten op de eindwaarde: anders duwt een groeiend getal de buren opzij.
  element.style.minWidth = `${Math.ceil(element.getBoundingClientRect().width)}px`;

  const state = { value: 0 };
  const format = (value) => (parts.grouped ? value.toLocaleString('nl-NL') : String(value));

  gsap.to(state, {
    value: parts.number,
    duration: 1.6,
    ease: 'power2.out',
    onUpdate: () => {
      element.textContent = parts.prefix + format(Math.round(state.value)) + parts.suffix;
    },
    onComplete: () => {
      element.textContent = parts.prefix + format(parts.number) + parts.suffix;
    },
  });
}
